import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export interface TabsState {
  [key: string]: number;
}

export interface TabState {
  name: string;
  index: number;
}

export const initialState: TabsState = { vehicleInformation: 0, customise: 0 };

export const tabsSlice = createSlice({
  name: 'tabs',
  initialState: initialState,
  reducers: {
    updateSelectedTab: (state, action: PayloadAction<TabState>) => {
      state[action.payload.name] = action.payload.index;
    },
  },
});

export const { updateSelectedTab } = tabsSlice.actions;

export const tabs = (state: RootState) => state.tabs;

export default tabsSlice.reducer;
